import {
	Text,
	Flex,
	Box,
	Spacer,
	Stack,
	Image,
	IconButton,
	Link as ChakraLink,
} from '@chakra-ui/react';
import { sitecoreAILogo } from '../../core/icons';
import { mdiMenu } from '@mdi/js';
import { FC, useState } from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { AppDrawer, Icon } from '../../../app/shared-components';
import { mainPaths } from '../../core/routes/paths';
import { handleTo } from '../../utils/helpers';
import UserMenu from './UserMenu';
import { AppSwitcher } from '../../../app/pages';
import { useGetOrganization } from '../../../app/services/organizations';
import NavigationVertical from '../components/NavigationVertical';

interface Props {
	lgSize: boolean;
}

export const TopBar: FC<Props> = ({ lgSize }) => {
	const [showSmLayoutDrawer, setShowSmLayoutDrawer] = useState(false);

	const { data: organizationsData } = useGetOrganization();
	const organizations = organizationsData?.data;

	return (
		<>
			<Flex data-testid="topbar">
				<Stack spacing="2" direction="row" alignItems="center">
					<AppSwitcher />
					<ChakraLink
						as={ReactRouterLink}
						to={handleTo(mainPaths.home)}
						display="inline-flex"
						borderRadius="md"
						_focusVisible={{
							boxShadow: 'outline',
							outline: 'none',
						}}
					>
						<Image
							alt="SitecoreAI Deploy logo"
							h="8"
							w="auto"
							p="1"
							src={sitecoreAILogo}
						/>
					</ChakraLink>

					{lgSize && (
						<Text variant="subtle" data-testid="organization-name">
							{organizations?.displayName}
						</Text>
					)}
				</Stack>

				<Spacer />
				<Box display="flex" flexDirection="row" gap="4">
					{!lgSize && (
						<IconButton
							variant="ghost"
							size="sm"
							aria-label="burger-menu"
							icon={<Icon path={mdiMenu} />}
							onClick={() => setShowSmLayoutDrawer(true)}
						/>
					)}
					{lgSize && <UserMenu />}
				</Box>
			</Flex>
			{showSmLayoutDrawer && (
				<AppDrawer
					isOpen={showSmLayoutDrawer}
					onClose={() => setShowSmLayoutDrawer(false)}
					drawerHeader={<DrawerHeader />}
					drawerBodyOnClick={() => setShowSmLayoutDrawer(false)}
					showBottomCloseButton={false}
					dataTestId="navigation-drawer"
				>
					<NavigationVertical />
				</AppDrawer>
			)}
		</>
	);
};

const DrawerHeader: FC = () => (
	<Box gap={5} display="flex">
		<UserMenu />
	</Box>
);
